import { render } from "./NotificationTemplatesSettings.vue?vue&type=template&id=14cc3647&scoped=true"
import script from "./NotificationTemplatesSettings.vue?vue&type=script&lang=js"
export * from "./NotificationTemplatesSettings.vue?vue&type=script&lang=js"

import "./NotificationTemplatesSettings.vue?vue&type=style&index=0&id=14cc3647&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cc3647"]])

export default __exports__